import Api from "./api";
import * as Constants from "../../../../consts/Constants.js";
import auth from "../../../auth/service";

const categoriesUrl = "/categories";

const DEVELOPER_ROLE = 2;

class PlaceCategoryService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(DEVELOPER_ROLE);
	}

}

export default new PlaceCategoryService(Constants.FINAL_URL_MAP_PLACES + categoriesUrl);